import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import BrandLogo from "@/assets/golfrecruit-lockup-light.svg";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface">
      <div className="text-center">
        <img src={BrandLogo} alt="golfrecruit.ai" className="mx-auto mb-8 h-9 w-auto" />
        <h1 className="mb-4 text-4xl font-bold text-foreground">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <Link to="/" className="font-medium text-primary-text underline hover:text-forest">
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
